"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWEET_ALERT_PROP_TYPES = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
exports.SWEET_ALERT_PROP_TYPES = {
    type: prop_types_1.default.oneOf(["default", "info", "success", "warning", "danger", "error", "input", "custom", "controlled"]),
    // shortcut props for type
    info: prop_types_1.default.bool,
    success: prop_types_1.default.bool,
    warning: prop_types_1.default.bool,
    danger: prop_types_1.default.bool,
    error: prop_types_1.default.bool,
    input: prop_types_1.default.bool,
    custom: prop_types_1.default.bool,
    controlled: prop_types_1.default.bool,
    title: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]).isRequired,
    onCancel: prop_types_1.default.func,
    onConfirm: prop_types_1.default.func.isRequired,
    confirmBtnText: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]),
    confirmBtnBsStyle: prop_types_1.default.string,
    confirmBtnCssClass: prop_types_1.default.string,
    confirmBtnStyle: prop_types_1.default.object,
    cancelBtnText: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]),
    cancelBtnBsStyle: prop_types_1.default.string,
    cancelBtnCssClass: prop_types_1.default.string,
    cancelBtnStyle: prop_types_1.default.object,
    btnSize: prop_types_1.default.string,
    customIcon: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.string]),
    show: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    placeholder: prop_types_1.default.string,
    validationMsg: prop_types_1.default.string,
    validationRegex: prop_types_1.default.object,
    defaultValue: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    inputType: prop_types_1.default.string,
    style: prop_types_1.default.object,
    closeBtnStyle: prop_types_1.default.object,
    customClass: prop_types_1.default.string,
    showConfirm: prop_types_1.default.bool,
    showCancel: prop_types_1.default.bool,
    showCloseButton: prop_types_1.default.bool,
    allowEscape: prop_types_1.default.bool,
    closeOnClickOutside: prop_types_1.default.bool,
    hideOverlay: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    focusConfirmBtn: prop_types_1.default.bool,
    focusCancelBtn: prop_types_1.default.bool,
    beforeMount: prop_types_1.default.func,
    afterMount: prop_types_1.default.func,
    beforeUpdate: prop_types_1.default.func,
    afterUpdate: prop_types_1.default.func,
    beforeUnmount: prop_types_1.default.func,
    timeout: prop_types_1.default.number,
    openAnim: prop_types_1.default.any,
    closeAnim: prop_types_1.default.any,
    reverseButtons: prop_types_1.default.bool,
    customButtons: prop_types_1.default.node,
    dependencies: prop_types_1.default.arrayOf(prop_types_1.default.any),
};
//# sourceMappingURL=prop-types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-sweetalert/dist/prop-types.js
// module id = 1862
// module chunks = 0